import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import styles from './SearchViewPreview.module.scss'

const cx = classnames.bind(styles);

const SearchViewPreview = function ({className, children}) {
  return (
    <div className={cx('root', className)}>
      SearchViewPreview Component
      <div>{children}</div>
    </div>
  )
}

SearchViewPreview.propTypes = {
  data: PropTypes.any
}

export default SearchViewPreview;
